export default __webpack_public_path__ + "assets/audio/1-50313721_clip.mp3";